import type {
  AnchorHTMLAttributes,
  ButtonHTMLAttributes,
  MouseEventHandler,
  ReactNode,
} from "react";
import "./styles.scss";

type Variant = "isp" | "mvno" | "glass" | "glass-dark";

interface GlassButtonProps {
  variant?: Variant;
  block?: boolean;
  children: ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  type?: "button" | "submit";
  onClick?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
}

export const GlassButton = ({
  variant = "isp",
  block = false,
  children,
  className = "",
  href,
  target,
  rel,
  type = "button",
  onClick,
}: GlassButtonProps) => {
  const cls = `glass-btn glass-btn--${variant} ${
    block ? "glass-btn--block" : ""
  } ${className}`.trim();

  if (href) {
    return (
      <a
        className={cls}
        href={href}
        target={target}
        rel={rel}
        onClick={onClick as AnchorHTMLAttributes<HTMLAnchorElement>["onClick"]}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      className={cls}
      type={type}
      onClick={onClick as ButtonHTMLAttributes<HTMLButtonElement>["onClick"]}
    >
      {children}
    </button>
  );
};
